/* eslint-disable @typescript-eslint/no-floating-promises */
import { Btn } from '@app/components/Btn';
import { FileUploadField } from '@app/components/FileUploadField';
import {
  ContentData,
  createFinacilaLiteracy,
  updateFinacilaLiteracy,
} from '@app/services/otherContentService';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';

interface Props {
  token: string;
  onClose: () => void;
  id?: string;
  defaultValues?: ContentData;
}
export function Form({ token, onClose, id, defaultValues }: Props) {
  const [values, setValues] = useState({
    url: defaultValues?.url || '',
    title: defaultValues?.title || '',
    description: defaultValues?.description || '',
    youtubeUrl: defaultValues?.youtubeUrl || '',
    btnText: defaultValues?.btnText || '',
  });
  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues(prev => ({ ...prev, [field]: event.target.value }));
    };

  const [image, setImage] = useState<File>();
  const fileOnChange = (files: File[]) => {
    if (files.length > 0) {
      setImage(files[0]);
    }
  };

  const queryClient = useQueryClient();
  const addMutation = useMutation(createFinacilaLiteracy, {
    onSuccess: () => {
      queryClient.invalidateQueries('financial-literacy');
      onClose();
    },
  });

  const editMutation = useMutation(updateFinacilaLiteracy, {
    onSuccess: () => {
      queryClient.invalidateQueries('financial-literacy');
      onClose();
    },
  });

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = {
      ...values,
      image,
    };
    if (id) {
      editMutation.mutate({ token, id, ...data });
    } else if (data.url) {
      addMutation.mutate({ token, ...data, image: data.image });
    }
  };

  const error = id ? editMutation.error : addMutation.error;
  const isLoading = editMutation.isLoading || addMutation.isLoading;

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <TextField
          fullWidth
          required
          type="url"
          size="small"
          label="Url"
          value={values.url}
          onChange={handleChange('url')}
        />
        <FileUploadField
          label="Image"
          onChange={fileOnChange}
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp']}
        />
        <TextField
          fullWidth
          type="url"
          size="small"
          label="Youtube Video Url"
          value={values.youtubeUrl}
          onChange={handleChange('youtubeUrl')}
        />
        <TextField
          fullWidth
          required
          type="text"
          size="small"
          label="Title"
          value={values.title}
          onChange={handleChange('title')}
        />
        <TextField
          multiline
          rows={4}
          fullWidth
          required
          type="text"
          size="small"
          label="Description"
          value={values.description}
          onChange={handleChange('description')}
        />
        <TextField
          fullWidth
          type="text"
          size="small"
          label="Button Text (Default: Learn More)"
          value={values.btnText}
          onChange={handleChange('btnText')}
        />

        {error && (
          <Typography color="error">{(error as Error).message}</Typography>
        )}
        <Stack direction="row" justifyContent="end" width={1} spacing={2}>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Btn
            variant="contained"
            color="primary"
            type="submit"
            isLoading={isLoading}
          >
            {id ? 'Update' : 'Create'}
          </Btn>
        </Stack>
      </Stack>
    </form>
  );
}
